import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
    width: fit-content;
    height: auto;
    min-width: ${({ minWidth }) => minWidth ? minWidth : 'auto'};
    padding: ${({ hasImage }) => hasImage ? '4px 4px 4px 8px' : '5px 8px'};

    max-width: ${({ maxWidth }) => maxWidth ? maxWidth : '125px'};

    gap: 4px;
    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 10rem;

    background-color: 
    ${({ disabled, status, backgroundColor }) => 
    disabled ? theme.colors.disabled.Desabilitado_Claro : 
    backgroundColor ? backgroundColor : 
    status === 'default' ? '#21262F14' : 
    status === 'success' ? '#2FBB6914' : 
    status === 'error' ? '#FF525214' : '#F8C84B14'};

    >span{
        width: fit-content;
        text-align: ${({ align }) => align ? align : 'flex-start'};

        display: flex;
        justify-content: flex-start;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ${({ noEllipsis }) => noEllipsis ? 'clip' : 'ellipsis'};
    }
`;

export const StatusCircle = styled.div`
    width: 12px;
    height: 12px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 50%;
    background-color: ${({ status }) => status === 'default' ? theme.colors.gray.Cinza_7 : status ===  'error' ? theme.colors.red.Vermelho_erro : theme.colors.yellow.Amarelo};
`;